import { template } from 'underscore';
import Backbone from 'backbone';
import DeviceConfig from '../config/devicesConfig.js';

export default Backbone.View.extend({
  initialize() {
    this.deviceList = DeviceConfig.devices;
    this.iconFolder = DeviceConfig.iconFolder;
    this.previewFrame = $(this.$el.siblings('.preview-container')[0]).find(
      'iframe'
    )[0];
    this.previewFrameContainer = $(
      $(this.$el.siblings('.preview-container .frame')[0]).find('.frame')[0]
    );
    DeviceConfig.devices;
    this.render();
  },
  events: {
    'click .device-icon': 'deviceChanged'
  },
  template: template(
    `    
    <% _.each(this.deviceList, function(device){ %>
            <div class="device-icon" data-id="<%= _.escape(device.id) %>">
                <img src="<%= this %><%= _.escape(device.icon) %>" data-id="<%= _.escape(device.id) %>" alt="" />
                <div class="device-tag"><%= _.escape(device.tag) %></div>
            </div>
        <% },[this.iconFolder]); %>
        `
  ),
  deviceChanged(event) {
    console.log('test1');
    var id = event.target.dataset.id;
    let element = '';
    event.target.tagName == 'IMG'
      ? (element = $(event.target.parentElement))
      : (element = $(event.target));
    element
      .addClass('active')
      .siblings()
      .removeClass('active');
    this.changeDevice(id);
  },
  changeDevice(deviceID) {
    let device = this.deviceList.filter(function(device) {
      return device.id == deviceID;
    })[0];
    let previewFramWidth = $('.preview-container').outerWidth();
    let res = device.resolution.split('*');
    let width = res[0];
    let height = res[1];
    this.previewFrameContainer.height(height + 'px');
    this.previewFrameContainer.width(width + 'px');
    let deviceScale = previewFramWidth / width;
    if (deviceScale > 1) {
      deviceScale = 1;
    }
    this.previewFrameContainer.css({
      transform: 'scale(' + deviceScale + ')',
      'margin-top': ''
    });
    this.previewFrame.height = height;
    this.previewFrame.width = width;

    var doc = $.find('#marketplace-preview-frame')[0].contentWindow.document; //that will look in the whole dom though
  },
  render() {
    $('.preview-wrapper .header .header-icon-container').html(this.template());
    this.$el.find('.device-icon:first-child').trigger('click');
  }
});
